export default __webpack_public_path__ + "static/media/arnold-joanna.97bc8f9c.png";